exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* color */\n\n  /* font */\n\n  /* link */\n}\n:root {\n  /* цвет */\n\n  /* TODO в фигме другие цвета по названиям scarlet magenta green beeline aquamarine violet, надо решить с дизайнерами  */\n\n  /* токены со ссылкой на глобал цвета */\n\n  /* шрифт */\n\n  /* отступы от шапки и футера до тела страницы */\n\n  /* ширина тела страницы */\n\n  /* отступы между элементами страницы */\n}\n.ServiceAdditional_component_1TQF {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 200px;\n  padding-left: 58px;\n}\n.ServiceAdditional_isMobile_2FfP {\n  padding: 16px 0 16px 58px;\n  width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"component": "ServiceAdditional_component_1TQF",
	"isMobile": "ServiceAdditional_isMobile_2FfP"
};